import { render, staticRenderFns } from "./ServiceOptions.vue?vue&type=template&id=22b8b52d&scoped=true&lang=pug"
import script from "./ServiceOptions.vue?vue&type=script&lang=js"
export * from "./ServiceOptions.vue?vue&type=script&lang=js"
import style0 from "./ServiceOptions.vue?vue&type=style&index=0&id=22b8b52d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b8b52d",
  null
  
)

export default component.exports